import React from "react";
import "./TrustedBySection.css";
import DepartmentforTransport from "../assets/images/DepartmentforTransport.png"
import TransportforLondon from "../assets/images/TransportforLondon.png"
import OrdanceSurvey from "../assets/images/OrdanceSurvey.png"
import MetropolitanPolice from "../assets/images/MetropolitanPolice.png"

import { motion } from "framer-motion";

const TrustedBySection = () => {
  const logos = [
    {
      name: "Department for Transport",
      src: DepartmentforTransport,
      alt: "Department for Transport"
    },
    {
      name: "Transport for London",
      src: TransportforLondon,
      alt: "Transport for London"
    },
    {
      name: "Ordnance Survey",
      src: OrdanceSurvey,
      alt: "Ordnance Survey"
    },
    {
      name: "Metropolitan Police",
      src: MetropolitanPolice,
      alt: "Metropolitan Police"
    },
  ];

  return (
    <motion.section
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }}
        >
    <section className="trusted-by-section">
      <div className="trusted-by-container">
        <h2 className="section-title">TRUSTED BY</h2>
        <div className="logo-grid">
          {logos.map((logo, index) => (
            <div key={index} className="logo-item">
              <img src={logo.src} alt={logo.alt} />
            </div>
          ))}
        </div>
      </div>
    </section>
    </motion.section>
  );
};

export default TrustedBySection;